import { ArrowDown } from 'lucide-react';

import { Button } from '@apps/web/components/ui/button';
import { cn } from '@apps/web/lib/utils';

export function ScrollToBottomButton({
    className,
    onClick,
    'aria-label': ariaLabel = 'Scroll to bottom',
    'aria-describedby': ariaDescribedBy,
}: {
    readonly className?: string;
    readonly onClick: () => void;
    readonly 'aria-label'?: string;
    readonly 'aria-describedby'?: string;
}) {
    return (
        <Button
            type="button"
            size="icon"
            variant="outline"
            aria-label={ariaLabel}
            aria-describedby={ariaDescribedBy}
            className={cn(
                'bg-background text-muted-foreground hover:text-foreground absolute bottom-3 left-1/2 z-20 size-8 -translate-x-1/2 rounded-full shadow-md',
                className,
            )}
            onClick={onClick}
        >
            <ArrowDown className="size-4" aria-hidden="true" />
        </Button>
    );
}
